import { dateTimeFunction } from "utils/date"

export const resolvePaymentModeKey = row => {
  const m = row?.modeOfPayment
  if (m == null) return undefined
  return typeof m === "object" ? (m?.key ?? m?.value) : m
}

export const mapAttachmentPayloads = attachments =>
  attachments?.map(e => ({
    file: e?.url?.split(",")?.[1],
    name: e?.name,
    attachmentTypeId: e?.attachmentTypeId,
    trackingId: e?.imageData?.id,
  }))

const collectRowAttachments = row => [
  ...(row?.bank_deposit_slip ? [row.bank_deposit_slip] : []),
  ...(row?.paymentProof ? [row.paymentProof] : []),
  ...(row?.receipt ? [row.receipt] : []),
  ...(row?.accountantReceipt ? [row.accountantReceipt] : []),
]

export const buildPaymentEntry = (row, modeOfPayments, banks) => {
  const modeKey = resolvePaymentModeKey(row)
  const modeOfPayment = modeOfPayments?.find(item => item?.key === modeKey)
  const bankId = banks?.find(item => item.key === row?.depositBank)?.id
  const rawAttachments = collectRowAttachments(row)
  const depositSlipRequired = {
    cash: true,
    cheque: true,
    bank_order: true,
  }
  return {
    amount: row?.amount,
    mode: row?.enableRA ? 2 : modeOfPayment?.id,
    ...(row?.referenceNumber && { referenceNumber: row.referenceNumber }),
    receiptNumber: row?.receiptNumber,
    ...(row?.chequeBank && { bankName: row.chequeBank }),
    ...(row?.fromAccountNumber && { fromAccountNumber: row.fromAccountNumber }),
    ...(row?.chequeDate && { chequeDate: row.chequeDate }),
    ...(row?.depositBank && { beneficiaryBankId: bankId }),
    ...(row?.depositSlipNumber && { transactionReferenceNumber: row.depositSlipNumber }),
    ...(row?.depositDate && {
      depositDate: dateTimeFunction({
        date: row.depositDate,
        timeZone: true,
        apiRequest: true,
      }),
    }),
    ...(row?.accountNumber && { beneficiaryAccountNumber: row.accountNumber }),
    ...(row?.depositBank && { bankKey: row.depositBank }),
    ...((row?.paymentType?.key || row?.paymentType) && {
      modeDisposition: row?.paymentType?.key || row?.paymentType,
    }),
    ...(row?.depositBank && { beneficiaryInternationalBankName: null }),
    ...(!!depositSlipRequired[row?.modeOfPayment] && {
      submitMode: row?.enableDepositRA ? "RACC" : "self_submit",
    }),
    ...(row?.enableDepositRA && { accountantId: row?.regional_accountant }),
    ...(row?.enableRA && {
      submitMode: "RACC",
      accountantId: row?.regional_accountant,
    }),
    ...(row?.bank && { bankName: row.bank }),
    ...(row?.transactionNumber && { referenceNumber: row.transactionNumber }),
    ...(row?.fromAccountTitle && { fromAccountTitle: row.fromAccountTitle }),
    ...(row?.beneficiaryAccountTitle && { beneficiaryAccountTitle: row.beneficiaryAccountTitle }),
    ...(row?.beneficiaryAccountNumber && { beneficiaryAccountNumber: row.beneficiaryAccountNumber }),
    ...(row?.transactionDate && {
      depositDate: dateTimeFunction({
        date: row.transactionDate,
        timeZone: true,
        apiRequest: true,
      }),
    }),
    ...(row?.payorderBank && { bankName: row.payorderBank }),
    ...(row?.payorderNumber && { referenceNumber: row.payorderNumber }),
    ...(row?.beneficiaryAccountNumberPayorder && {
      fromAccountNumber: row.beneficiaryAccountNumberPayorder,
    }),
    ...(row?.dateOfTransaction && { transactionDate: row.dateOfTransaction }),
    ...(row?.transactionId && { referenceNumber: row.transactionId }),
    ...(rawAttachments?.length && { attachments: mapAttachmentPayloads(rawAttachments) }),
    paymentContractTypeOverride: row?.buyerFee ? "vas" : "developer",
  }
}

/** Multi-payment form uses `values.payments`; legacy single-payment uses root fields on `values`. */
export const normalizePaymentRows = values => {
  if (Array.isArray(values?.payments) && values.payments.length > 0) {
    return values.payments
  }
  return [values]
}
